import { DatePipe } from "@angular/common";
import { Mappable} from "../../../_shared/mappable.class";
import { GraphBar } from "../../graph/GraphBar";
import { BreakdownType, Cue5050BaseReport } from "./Cue5050BaseReport";

export class Cue5050PlayersReport implements Mappable<Cue5050PlayersReport>, Cue5050BaseReport{
    constructor(data: Partial<Cue5050PlayersReport>) {
        Object.assign(this, data);
        this.datePipe = new DatePipe("en-US");
    }

    datePipe: DatePipe;

    cue5050Id: number;
    name: string;
    eventStartDate: Date;
    eventEndDate: Date;
    totalPlayers: number;
    returningPlayers: number;
    newPlayers: number;

    getBarMappingsByBreakdownType(type: BreakdownType): GraphBar {
        return this.getPlayersMapping();
    }
    getBreakdownTypes(): BreakdownType[] {
        return [BreakdownType.PlayersByReturning];
    }
    getBreakdownByBreakdownType(type: BreakdownType): string[] {
        return ["Returning Players", "New Players"];
    }
    getYAxisName() {
        return 'Total Players';
    }
    getXAxisName(){
        return 'Event Date';
    }

    getPlayersMapping(): GraphBar{
        return {
            name: this.datePipe.transform(this.eventStartDate),
            description: this.name,
            size: this.totalPlayers,
            segments: [{name: "Returning Players", size: this.returningPlayers}, 
                       {name: "New Players", size: this.newPlayers}]
        } as GraphBar
    }
}